import { useScript } from '../../hooks';
import { CookieConsentProps } from './CookieConsent.types';
import './CookieConsent.scss';

const CookieConsent = ({ cbid }: CookieConsentProps) => {
  useScript(
    'https://consent.cookiebot.com/uc.js',
    'Cookiebot',
    [
      { attribute: 'data-cbid', value: cbid },
      { attribute: 'data-framework', value: 'TCFv2.2' },
      { attribute: 'type', value: 'text/javascript' },
    ],
    false
  );

  return null;
};

export default CookieConsent;
